/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Standalone_HintInputs */

const cs_social_standalone_hint = /** @type {(inputs: Social_Standalone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořte Typst plakát nebo nahrajte vlastní média — bez vazby na inzerát.`)
};

const en_social_standalone_hint = /** @type {(inputs: Social_Standalone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a Typst poster or upload your own media — no listing required.`)
};

/**
* | output |
* | --- |
* | "Create a Typst poster or upload your own media — no listing required." |
*
* @param {Social_Standalone_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_standalone_hint = /** @type {((inputs?: Social_Standalone_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Standalone_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_standalone_hint(inputs)
	return cs_social_standalone_hint(inputs)
});